import React from 'react';
import CarouselServicos from '../components/carouselServicios';
import FloatingButton from '../components/buttonFlotanteWha';

import Gallery from '../components/gallery';
import "./styles.css"
import CE1 from "../assets/images/otros/CE1.jpg"
import CE2 from "../assets/images/otros/CE2.jpg"
import CE3 from "../assets/images/otros/CE3.jpg"
import CE4 from "../assets/images/otros/CE4.jpg"
import S1 from "../assets/images/otros/S1.jpg"
import S2 from "../assets/images/otros/S2.jpg"
import S3 from "../assets/images/otros/S3.jpg"
import S4 from "../assets/images/otros/S4.jpg"
import EP1 from "../assets/images/otros/EP1.jpg"
import EP2 from "../assets/images/otros/EP2.jpg"
import EP3 from "../assets/images/otros/EP3.jpg"
import EP4 from "../assets/images/otros/EP4.jpg"
import EL1 from "../assets/images/otros/EL1.jpg"
import EL2 from "../assets/images/otros/EL2.jpg"
import EL3 from "../assets/images/otros/EL3.jpg"
import EL4 from "../assets/images/otros/EL4.jpg"



const imagenes= [ CE1, CE2, CE3, CE4];
const imagenes2=[S1,S2,S3,S4];
const imagenes3=[EP1,EP2,EP3,EP4];
const imagenes4=[EL1,EL2,EL3,EL4];


function OtrosServicios(){
    return(
        <div className="fflex flex-col items-center p-10 space-y-10 min-h-screen animated-background">
            <CarouselServicos/>


         



 <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
        {/* Galería de imágenes con altura igual */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[400px]">
            <Gallery titulo="CONSULTORIA A ENTIDADES PÚBLICAS Y PRIVADAS" imagenes={imagenes} />
        </div>

        {/* Sección de Descripción con altura igual */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg text-justify text-gris-oscuro leading-relaxed min-h-[400px] flex flex-col justify-center">
           
            <p className='text-gray-700 mb-4 text-justify'>
            Establecemos servicios dirigidos principalmente a las empresas ya creadas o nueva con objeto de prestarles un servicio personalizado de tutelaje en una serie de ámbitos de la gestión empresarial que se consideran claves o estratégicos para el buen desarrollo del negocio. El alcance de este servicio incluye asesoramiento sobre organigramas y funciones, sistemas de gestión empresarial, indicadores de gestión, etc. También incluye asesoramiento en planificación vinculado a la orientación estratégica del negocio.
            </p>
          
           
        </div>
    </div>
</div>




    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          La evaluación es un proceso para medir el conocimiento y el rendimiento laboral del trabajador, con el objeto de llegar a la toma de decisiones objetivas. Las organizaciones grandes y modernas utilizan la evaluación del trabajador para determinar incrementos de sueldos, necesidades de capacitación y desarrollo. La evaluación del personal nuevo o ya trabajador, se convierte en un proceso para estimular o juzgar el valor, la excelencia y las cualidades del desempeño del personal, es una herramienta de dirección, imprescindible en la actividad administrativa, ayuda a determinar políticas de recursos humanos adecuados a las necesidades de la organización. La evaluación amplia las bases de información del departamento de personal. Estos conocimientos sirven para la retroalimentación que reciben los trabajadores sobre su desempeño.
          </p>

          {/* 📌 Lista de Temas */}
          <h3 className="text-lg font-semibold  mb-2">
          Con la evaluación del desempeño del personal se obtiene:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Mejorar el rendimiento en el trabajo. a mejores costos de operación.            </li>
            <li>Detectar posibles errores de asignación de personal, determinando necesidades de reubicación.</li>
            <li>Apoyar la investigación de necesidades de capacitación y desarrollo del personal.</li>
            <li>Servir como una oportunidad de retropulsión para el trabajador, respecto a cómo se está y cuáles pueden ser sus proyecciones en las empresas.
            </li>
            <li>Conciliar al trabajador en los aspectos que precisa mejorar, para la efectiva realización de su labor.</li>
            <li>Comprobar la eficiencia y determinar la efectividad del proceso de selección del personal.</li>
            <li>Conocer el potencial humano de la empresa.</li>
            
          </ul>

        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="SELECCION Y EVALUACIÓN DE PERSONAL" imagenes={imagenes2} />
        </div>  
      </div>
    </div>



    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl gap-6 md:gap-8">
        
        {/* Galería de imágenes - Misma altura que el texto */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex flex-col h-full">
            <Gallery 
                titulo="ALQUILER DE EQUIPOS PESADOS" 
                imagenes={imagenes3}
                className="h-full flex-grow"
            />
        </div>

        {/* Sección de Descripción - Misma altura que galería */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg flex flex-col h-full">
            <div className="text-gris-oscuro leading-relaxed text-justify flex-grow overflow-auto">
                <p className="mb-4">
               <strong>CECOMP.</strong>  También, cuenta un área que está orientada al Alquiler de Maquinaria Pesada, que contribuye al mejoramiento de los procesos productivos de sus clientes, mediante calidad y eficiencia a través de un equipo humano altamente calificado, motivado y comprometido. Nuestros equipos pesados, cuenta con tecnología de punta de excelente nivel para cumplir los requerimientos necesarios.
                </p>
                <h3 className="text-lg font-semibold  mb-2">
                Contamos con:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Excavadoras          </li>
            <li>Cargador Frontal</li>
            <li>Motoniveladoras</li>
            <li>Rodillos Compactador
            </li>
            <li>Retroexcavadora</li>
            <li>Volquete</li>
            <li>Etc</li>
            
          </ul>
              
            </div>
        </div>
    </div>
</div>



<div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          CECOMP, también cuenta con un área que está enfocado al alquiler de vehículos livianos, que contribuye al mejoramiento de los procesos productivos de sus clientes, mediante calidad y eficiencia a través de un equipo humano altamente calificado, motivado y comprometido.
          </p>

          {/* 📌 Lista de Temas */}
          <h3 className="text-lg font-semibold  mb-2">
          Contamos con vehículos modernos para ayudarte a culminar tu proyecto sin tener contra tiempos:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Buses
            </li>
            <li>Cuaster</li>
            <li>Camioneta</li>
           
          </ul>

        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="ALQUILER DE EQUIPOS LIVIANOS" imagenes={imagenes4} />
        </div>  
      </div>
    </div>







          
          
<FloatingButton/>
       
        </div>
        
    );
}
export default OtrosServicios;